import React from "react";
import * as firebaseui from "firebaseui";
import { Container } from "react-bootstrap";
import { firebase } from "../firebase/firebase";
import { setContent, getContent } from "../firebase/content";
import { updateContent } from "../actions/cartAction";
import ContactInfo from "./ContactInfo";
import ListOfOrder from "./ListOfOrder";
import { connect } from "react-redux";
import About from "./About";
import Products from "./Products";
import NutritionFacts from "./NutritionFacts";
import MacaDishes from "./MacaDishes";
import Contact from "./Contact";
import ImageManager, { ImageManagerContext } from "./ImageManager";
import AlertUpdate from "./AlertUpdate";

const ui = new firebaseui.auth.AuthUI(firebase.auth());

class AdminPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connected: false,
      editable: true,
      imageCallback: null,
      showAlert: false,
    };
    this.handleShowAlert = this.handleShowAlert.bind(this);
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        // console.log('authentication required')
        this.setState({
          connected: false,
        });
        ui.start("#firebase-auth", {
          signInOptions: [
            {
              provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
              scopes: ["https://www.googleapis.com/auth/contacts.readonly"],
              customParameters: {
                // Forces account selection even when one account
                // is available.
                prompt: "select_account",
              },
            },
            firebase.auth.EmailAuthProvider.PROVIDER_ID, // Other providers don't need to be given as object.
          ],
          callbacks: {
            signInSuccess: () => false,
            signInFailure: (error) => {
              console.error(error);
            },
          },
        });
      } else {
        user.getIdTokenResult().then((token) => {
          if (token.claims.admin) {
            // console.log('admin anthenticated')
            this.setState({
              connected: true,
            });
          } else {
            console.error("not admin");
            // this.context.router.history.push("/");
          }
        });
      }
    });
  }
  onSave() {
    setContent(this.props.content)
      .then(() => {
        // console.log('saved')
        return getContent();
      })
      .then((content) => {
        return this.props.updateContent(content);
      });
  }
  handleShowAlert(event) {
    event.preventDefault();
    this.setState({
      showAlert: !this.state.showAlert,
    });
  }
  render() {
    let { editable } = this.state;
    return (
      <ImageManagerContext.Provider
        value={{
          callback: this.state.imageCallback,
          request: (callback) => {
            this.setState({ imageCallback: callback });
          },
          clear: () => {
            this.setState({ imageCallback: null });
          },
        }}
      >
        <div>
          {this.state.connected ? (
            <Container className="admin-page">
              <ImageManager isOpen={true} />
              <h1>Welcome to Admin Page</h1>
              <ListOfOrder />
              <ContactInfo />
              <div className="sticky-button">
                <h2>
                  You can edit your page here
                  <button
                    onClick={() => {
                      this.onSave();
                      this.handleShowAlert();
                    }}
                  >
                    Save
                  </button>
                </h2>
                {this.state.showAlert && <AlertUpdate />}
              </div>
              <About editable={editable} />
              <Products editable={editable} />
              <NutritionFacts editable={editable} />
              <MacaDishes editable={editable} />
              <Contact editable={editable} />
            </Container>
          ) : (
            <div id="firebase-auth"></div>
          )}
        </div>
      </ImageManagerContext.Provider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    images: state.images,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateContent() {
      dispatch(updateContent(...arguments));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);
